import { getInfCLogger } from '@infodata-group/inf-commons-core';
import { Entity } from '../model/entity/entity';
import { NameValue } from '../tool/name-value';
import { CommonUtils } from '../tool/common-utils';

const logger = getInfCLogger('StandardEntity');

export class StandardEntity extends Entity {
  public id: string;
  public label: string;
  public display: 'full' | 'id' | 'label';
  public icon: string;

  [key: string]: any;

  constructor(
    id?: string,
    label?: string,
    display: 'full' | 'id' | 'label' = 'full',
  ) {
    super();
    this.id = id;
    this.label = label;
    this.display = display;
  }

  public override toString(): string {
    switch (this.display) {
      case 'full':
        return this.getFullString();
      case 'id':
        return this.id ? this.id : '-';
      case 'label':
        return this.label ? this.label : '-';
      default:
        return '-';
    }
  }

  private getFullString() {
    if (this.id && this.label) {
      return `${this.id} - ${this.label}`;
    }
    if (this.label) {
      return this.label;
    }
    if (this.id) {
      return this.id;
    }
    return '-';
  }

  serialize(): any {
    const value: any = {};
    for (const attr in this) {
      if (
        attr !== 'display' &&
        Object.hasOwn(this, attr) &&
        this[attr] !== undefined
      ) {
        try {
          value[attr] = (this[attr] as any).serialize();
        } catch (e) {
          // Expected for the attributes without serialize (strings, numbers): not an error
          logger.debug(`Attribute "${attr}" kept as is`, e);
          value[attr] = this[attr];
        }
      }
    }
    return value;
  }

  public getId() {
    return this.id;
  }

  public getLabel() {
    return this.label;
  }

  public override compare(comparant: any, byLabel?: boolean): number {
    if (
      comparant instanceof Entity ||
      typeof comparant === 'string' ||
      comparant instanceof NameValue
    ) {
      return super.compare(comparant, byLabel);
    }
    if (comparant[this.id]) {
      return CommonUtils.compare(this.getId(), comparant[this.id]);
    }
    if (comparant && Object.hasOwn(comparant, 'id')) {
      return CommonUtils.compare(this.getId(), comparant.id);
    } else {
      return NaN;
    }
  }
}
